// extracted by mini-css-extract-plugin
export default {"layout":"DefaultLayout_layout__PSEXa","content":"DefaultLayout_content__e9Pwb"};